import React from "react";
import { Fragment, useEffect } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { styled } from "styled-components";

const ListOption = styled.ul`
    position: absolute !important;
    z-index: 10 !important;
    margin-top: 0.25rem !important;
    max-height: 15rem !important;
    width: fit-content !important;
    overflow: auto !important;
    border-radius: 0.375rem !important;
    background-color: #ffffff !important;
    padding-top: 0.25rem !important;
    padding_bottom: 0.25rem !important;
    font-size: 1rem !important;
    line-height: 1.5rem !important;
    list-style: none !important;
    padding-inline-start: 0 !important;
`;

const Label = styled.label`
    display: block !important;
    font-size: 1.125rem !important;
    line-height: 1.5rem !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    margin-bottom: 15px !important;
    font-family: "Red Hat Display" !important;
`;

const ListBox = styled.button`
    position: relative !important;
    cursor: default !important;
    border-radius: 0.375rem !important;
    background-color: transparent !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    padding-left: 0.75rem !important;
    padding-left: 0.75rem !important;
    text-align: left !important;
    width: 80vw !important;
    border: 1px solid #ffffff !important;
    color: #ffffff !important;
    @media (min-width: 640px) {
        font-size: 0.875rem !important;
        line-height: 1.5rem !important;
    }
    @media (min-width: 768px) {
        width: 250px !important;
    }
`;
// se-flex- se-flex se-justify-between se-items-center se-gap-5
const ListBoxWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
        gap: 1.25rem;
    }
`

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

function decodeHTMLEntities(text) {
    var textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
}

const FilterOptionInput = ({ onSelected, data_options, label, selectedValue, className }) => {
    useEffect(() => {}, []);

    const selectedHandlder = (e) => {
        onSelected(e);
    };

    return (
        <Listbox
            value={selectedValue}
            onChange={selectedHandlder}>
            {({ open }) => (
                <ListBoxWrapper className={`${className}`}>
                    <Listbox.Label as={Label}>{label}</Listbox.Label>
                    <div className="se-relative">
                        <Listbox.Button as={ListBox}>
                            <span className="se-block se-truncate">{decodeHTMLEntities(selectedValue.name)}</span>
                            <span className="se-pointer-events-none se-absolute se-inset-y-0 se-right-0 se-flex se-items-center se-pr-2">
                                <ChevronUpDownIcon
                                    className="se-h-5 se-w-5 se-text-gray-400"
                                    aria-hidden="true"
                                />
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="se-transition se-ease-in se-duration-100"
                            leaveFrom="se-opacity-100"
                            leaveTo="se-opacity-0">
                            <Listbox.Options as={ListOption}>
                                {data_options.map((option) => (
                                    <Listbox.Option
                                        key={option.id}
                                        className={({ active }) => classNames(active ? "se-bg-sorange-40 se-text-white" : "se-text-gray-900", "se-relative se-cursor-default se-select-none se-py-2 se-pl-3 se-pr-9")}
                                        value={option}>
                                        {({ selected, active }) => (
                                            <>
                                                <span className={classNames(selected ? "se-font-semibold" : "se-font-normal", "se-block truncate")}>{decodeHTMLEntities(option.name)}</span>

                                                {selected ? (
                                                    <span className={classNames(active ? "se-text-white" : "se-text-sorange-40", "se-absolute se-inset-y-0 se-right-0 se-flex se-items-center se-pr-4")}>
                                                        <CheckIcon
                                                            className="se-h-5 se-w-5"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </ListBoxWrapper>
            )}
        </Listbox>
    );
};

export default FilterOptionInput;
